export default "__VITE_ASSET__CbFYVbIO__"